module.exports = __webpack_public_path__ + "img/woman-writing-cv.2254fb81.jpg";